var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-bar"},[_c('self-building-square-spinner',{staticClass:"loading-element",attrs:{"animation-duration":4000,"size":60,"color":"#488c4e"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }